import { c as _c } from "react/compiler-runtime";
import type { InterfaceInputToken } from '@morpho-org/dapp-core';
import { ChainUtils } from '@morpho-org/blue-sdk';
import { Avatar, ClipboardButton } from '@morpho-org/ui-v6/client';
import { isZeroAddressOrUnset } from '@morpho-org/ui-v6/utils';
import { abbreviateAddress } from '@repo/utils';
import { memo, useMemo } from 'react';
import { ButtonLink } from '@/components/common/ButtonLink';
export interface AssetRewardHoverCardProps {
  asset: InterfaceInputToken;
  type: string;
}
const AssetRewardHoverCard = t0 => {
  const $ = _c(26);
  const {
    asset
  } = t0;
  let t1;
  if ($[0] !== asset.address || $[1] !== asset.chain.id) {
    t1 = ChainUtils.getExplorerAddressUrl(asset.chain.id, asset.address);
    $[0] = asset.address;
    $[1] = asset.chain.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const addressLink = t1;
  let t2;
  if ($[3] !== asset.address) {
    t2 = abbreviateAddress(asset.address);
    $[3] = asset.address;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const formattedAddress = t2;
  let t3;
  if ($[5] !== asset.address) {
    t3 = isZeroAddressOrUnset(asset.address);
    $[5] = asset.address;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const isAddressValid = !t3;
  let t4;
  if ($[7] !== asset.logoURI) {
    t4 = <Avatar src={asset.logoURI} />;
    $[7] = asset.logoURI;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== asset.symbol) {
    t5 = <span className="text-2xs">{asset.symbol}</span>;
    $[9] = asset.symbol;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== asset.address || $[12] !== isAddressValid) {
    t6 = isAddressValid && <ClipboardButton toCopy={asset.address} toastMessage="Address copied to clipboard." tooltipMessage="Copy address." size="sm" />;
    $[11] = asset.address;
    $[12] = isAddressValid;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div className="gap-2xs flex items-center">{t4}{t5}{t6}</div>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== formattedAddress) {
    t8 = {
      variant: "secondary",
      size: "sm",
      label: formattedAddress
    };
    $[18] = formattedAddress;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== addressLink || $[21] !== t8) {
    t9 = <ButtonLink href={addressLink} buttonProps={t8} />;
    $[20] = addressLink;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t7 || $[24] !== t9) {
    t10 = <div className="p-sm h-lg box-content flex items-center justify-between">{t7}{t9}</div>;
    $[23] = t7;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export default memo(AssetRewardHoverCard);